<ion-content class="modal-outher-container">
  <ion-grid
    class="modal-inner-container mobile-filter__container custom-scrollbar"
  >
    <ion-header *ngIf="p.renderMobile">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="onClearFilters()">
            {{ 'CLEAR' | translate }}
          </ion-button>
        </ion-buttons>
        <ion-title>{{ 'FILTER' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button
            class="inheader"
            fill="clear"
            color="dark"
            (click)="onCloseModal()"
          >
            <ion-icon name="close" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <app-modal-header
      *ngIf="!p.renderMobile"
      header="{{ 'FILTER' | translate }}"
      (close)="onCloseModal()"
    >
    </app-modal-header>

    <ion-row>
      <ng-content select="[content]"></ng-content>
    </ion-row>

    <ion-row class="mobile-filter__filter-button-container">
      <ion-col class="ion-text-center">
        <ion-button
          (click)="emitCustomEventFromButton ? onShowResults() : onCloseModal()"
          expand="full"
          shape="round"
        >
          {{ 'SPACE.SHOW_RESULTS' | translate }}
          <ng-content select="[button]"></ng-content>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
